import * as React from 'react';

import { Textarea } from '@/components/ui/textarea';
import type { StringLiteralDataType } from '@glueapp/graph-types';

interface ShapeStringLiteralEditorProps {
    value: StringLiteralDataType;
    onChange: (value: StringLiteralDataType) => void;
}

export const ShapeStringLiteralEditor: React.FC<ShapeStringLiteralEditorProps> = ({ value, onChange }) => {
    return (
        <div className="flex flex-col gap-1.5 pt-1">
            <label className="text-xs font-medium text-muted-foreground">Text value</label>
            <Textarea
                placeholder="Enter text..."
                value={value.stringLiteral}
                onChange={e => onChange({ kind: 'stringLiteral', stringLiteral: e.target.value })}
            />
        </div>
    );
};
